import React from 'react';
import PopupAction from 'components/Misc/PopupActions/components/PopupAction';
import { Action } from 'helpers';
import { Divider } from '@mui/material';

function ClientManagementPopup({ object, level, onClose }) {
    return (
        <React.Fragment>
            <PopupAction
                action={Action.Edit}
                object={object}
                level={'client'}
                showLabel={true}
                onActionHandled={onClose}
            />
            <Divider />
        </React.Fragment>
    );
}

export { ClientManagementPopup };
